import React from 'react';

import { Container, makeStyles, Typography } from '@material-ui/core';

import Footer from '../../components/footer/Footer';
import ForgotPassword from '../../components/forgotPassword/ForgotPassword';
import LoginHeader from '../../components/login/LoginHeader';

const useStyles = makeStyles(() => {
  return {
    formTitle: {
      color: '#172B4D',
      fontSize: '30px',
      fontWeight: 'bold',
      marginBottom: '16px',
    },
    loginHint: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '22px',
      marginBottom: '30px',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: '410px',
      paddingBottom: '42px',
      paddingTop: '42px',
    },
    parentContainer: {
      display: 'grid',
      minHeight: '100vh',
    },
  };
});

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.parentContainer}>
      <div style={{ marginBottom: 'auto' }}>
        <LoginHeader />
      </div>

      <div style={{ margin: 'auto' }}>
        <Container component="main" className={classes.mainContainer}>
          <Container component="div" disableGutters>
            <Typography variant="h4" className={classes.formTitle} align="center">
              Forgot your password?
            </Typography>
            <Typography variant="body1" className={classes.loginHint} align="center">
              Confirm your email and we’ll send you the instructions to create a new password.
            </Typography>
          </Container>
          <ForgotPassword />
        </Container>
      </div>

      <div style={{ marginTop: 'auto' }}>
        <Footer />
      </div>
    </div>
  );
};
